import { useState, useEffect, createContext, useContext } from "react";
import { supabase } from "../herlpers/supabaseClient";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    (async function () {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();
      if (!error) setUser(user);
      const res = await supabase.auth.getSession()
      if(!res.error)
      setToken(res.data?.session?.access_token);
    })();
  }, []);

  useEffect(() => {
    const auth = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN") {
        setUser(session.user)
        setToken(session.access_token)
      }
      if (event === "SIGNED_OUT"){
        setUser(null);
        setToken(null);
      }
    });

    return () => {
      if (auth.data && auth.data.unsubscribe) auth.data.unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user,token, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
